import { render, staticRenderFns } from "./BrowseModeSidebarPanels.vue?vue&type=template&id=b3e248e0&"
import script from "./BrowseModeSidebarPanels.vue?vue&type=script&lang=ts&"
export * from "./BrowseModeSidebarPanels.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports